export default __webpack_public_path__ + "static/media/linny_kimly_phuong.fcfc599a.jpg";